import { type FC } from 'react';
import { observer } from 'mobx-react-lite';
import { appFactory } from '../../app';
import { QuestionView } from '../QuestionView';
import { SurveyProgressBar } from '../SurveyProgressBar';
import { LastPageView, LastPageModel } from '../LastPageView';
import styles from './SurveyView.module.scss';

export const SurveyView: FC = observer(() => {
  const { app } = appFactory;
  if (!app?.survey) {
    return null;
  }

  const { survey } = app;
  const { currentQuestionModel } = survey;

  return (
    <div className={styles.SurveyView}>
      <SurveyProgressBar survey={survey} />

      {currentQuestionModel instanceof LastPageModel ? (
        <LastPageView questionModel={currentQuestionModel} />
      ) : (
        <QuestionView survey={survey} />
      )}
    </div>
  );
});
